import { render } from "./Linkedin.vue?vue&type=template&id=2f0c5971"
const script = {}
script.render = render

export default script